import $ from 'jquery';

export default function Employee(vm) {
    this.all = function(params) {
        var url = '/employee/list?' + $.param(params);

        return vm.get(url);
    };

    this.create = function(params) {
        var url = '/employee/create';

        return vm.post(url, params);
    };

    this.get = function(id) {
        var url = '/employee/detail/' + id;

        return vm.get(url);
    };

    this.delete = function(params) {
        var url = null;

        if (params.is_permanent == 1)
            url = '/employee/force-delete/' + params.id;
        else
            url = '/employee/delete/' + params.id;

        return vm.delete(url);
    };

    this.restore = function(id) {
        var url = '/employee/restore/' + id;

        return vm.get(url);
    };

    this.invite = function(params) {
        var url = '/employee/invite';

        return vm.post(url, params);
    };

    this.email = function(params) {
        var url = '/employee/email';

        return vm.post(url, params);
    };
}